import React from 'react'
import { useIntl } from 'react-intl'
import Final from '../FolderTreeStructureLib'
import { moveFileToFolder } from '../../core/_requests'
import { toast } from 'react-toastify'
import { useMoveToFolderData } from '../../core/FileToFolderAuth'
import { Modal } from 'react-bootstrap'
import { BasicButton } from '../../../widgets/components/UI/BasicButton'
import { useAuth } from '../../../../modules/auth/index'
// import FinalDataRoom from '../FolderTreeStructureDataRoom'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'

export default function MoveFolderModal({
  MoveToFolderModal,
  setMoveToFolderModal,
  moveLoading,
  toBeMovedId,
  setIsMoving,
  getBreadcrumb,
  moveToFolderDr,
  setMoveToFolderDr,
  changeFunc,
  getCompanyFolderChildren,
  companyFolderContentId,
}: {
  MoveToFolderModal: boolean
  setMoveToFolderModal: (value: boolean) => void
  moveLoading: boolean
  toBeMovedId: string
  setIsMoving: (value: boolean) => void
  getBreadcrumb: (value: string) => void
  moveToFolderDr?: boolean
  setMoveToFolderDr?: any
  changeFunc?: boolean
  getCompanyFolderChildren: (value: any) => void
  companyFolderContentId: string
}) {
  const { formatMessage } = useIntl()
  const { contentID, breadcrumbContentId, breadCrumbLatestElementId } = useMoveToFolderData()
  const { companyId, currentUser } = useAuth()
  const handleFileToFolder = async (contentID: string | undefined) => {
    try {
      setIsMoving(true)
      if (toBeMovedId && companyId) {
        const {
          data: { success, errors },
        } = await moveFileToFolder(toBeMovedId, contentID, +companyId)
        if (success) {
          setIsMoving(false)
          setMoveToFolderModal(false)
          // setMoveToFolderDr(false);
          toast.success(formatMessage({ id: 'File Moved Successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.MoveFileToFolderSuccessful,
              action: 'normal',
              metadata: {
                moved_folder_id: toBeMovedId,
                content_id: contentID,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
          if (changeFunc) {
            if (companyFolderContentId === breadCrumbLatestElementId) {
              getCompanyFolderChildren(breadCrumbLatestElementId)
            } else {
              getBreadcrumb(breadCrumbLatestElementId)
            }
          } else {
            if (companyFolderContentId === breadcrumbContentId) {
              getCompanyFolderChildren(breadcrumbContentId)
            } else {
              getBreadcrumb(breadcrumbContentId)
            }
          }
        } else {
          setIsMoving(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.MoveFileToFolderFailed,
              action: 'normal',
              metadata: {
                moved_folder_id: toBeMovedId,
                content_id: contentID,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <Modal
      show={MoveToFolderModal}
      onHide={() => setMoveToFolderModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <h2>{formatMessage({ id: 'Move to Folder' })}</h2>
      </Modal.Header>
      <Modal.Body>
        {/* {(moveToFolderDr)?
              (<FinalDataRoom toBeMovedId={toBeMovedId}/>)
              :
         (  */}
        <Final toBeMovedId={toBeMovedId} />
        {/* )
            } */}
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex flex-md-row flex-column gap-2 w-100 justify-content-md-end'>
          <BasicButton
            height='44px'
            border='none'
            color='#F5F8FA'
            textColor='#7E8299'
            padding='12px 16px'
            onClick={() => {
              setMoveToFolderModal(false)
            }}
            buttonText='Close'
            minWidth={56}
            customClass='order-2 order-md-1'
          />

          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              handleFileToFolder(contentID)
            }}
            buttonText={formatMessage({ id: '  Move to folder' })}
            minWidth={56}
            loading={moveLoading}
            disabled={moveLoading}
            customClass='order-1 order-md-2'
          />
        </div>
      </Modal.Footer>
    </Modal>
  )
}
